<template>
<div>
    <navbar></navbar>
  <section class="section">
    <title-bar>
    Sample Industry Financial Statement -- {{industryname}}
    </title-bar>

    <div class="level">
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">NAICS</p>
      <p class="title">{{naics}}</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Geography</p>
      <p class="title">{{geography}}</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Sales Size</p>
      <p class="title">{{salesSize}}</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Units</p>
      <p class="title">{{dollarUnits}}</p>
    </div>
  </div>
</div>

    <tiles>
    <card-widget class="tile is-child" type="is-primary" icon="domain"  v-bind:number="firms"  label="Firms"/>
    <card-widget class="tile is-child" type="is-primary" icon="square-inc-cash"  v-bind:number="sales" prefix="$" label="Avg. Sales"/>
    <card-widget class="tile is-child" type="is-primary" icon="label-percent"  v-bind:number="growth" suffix="%"  label="Growth(5yr)"/>
    </tiles>
    <tiles>
      <card-widget class="tile is-child" type="is-primary" icon="square-inc-cash"  v-bind:number="grossmargin"  prefix="$"  label="Gross Margin"/>
      <card-widget class="tile is-child" type="is-primary" icon="square-inc-cash"  v-bind:number="profitmargin" prefix="$"   label="Profit Margin"/>
      <card-widget class="tile is-child" type="is-primary" icon="division-box"  v-bind:number="assets2sales" label="Assets / Sales"/>
    </tiles>
    <div class="columns">
  <div class="column">
    <card-component title="Sales Trend - Last 5 Years" @header-icon-click="fillChartData" icon="finance" header-icon="reload">
      <div v-if="lineChart.chartData" class="chart-area">
        <line-chart style="height: 100%"
                    ref="bigChart"
                    chart-id="big-line-chart"
                    :chart-data="lineChart.chartData"
                    :extra-options="lineChart.extraOptions">
        </line-chart>
      </div>
    </card-component>
    </div>
  <div class="column">
    <card-component title="Sales Trend - Great Recession(2008-2010)" @header-icon-click="fillChartDataGreat" icon="finance" header-icon="reload">
      <div v-if="lineChartGreat.chartData" class="chart-area">
        <line-chart-great style="height: 100%"
                    ref="bigChartGreat"
                    chart-id="big-line-chart-great"
                    :chart-data="lineChartGreat.chartData"
                    :extra-options="lineChartGreat.extraOptions">
        </line-chart-great>
      </div>
    </card-component>
    </div>

    </div>

    <card-component title="Benchmark Performance" @header-icon-click="fillBarChartData" icon="finance" header-icon="reload">
      <div v-if="defaultChart.chartData" class="chart-area">
        <bar-chart style="height: 100%"
                    ref="bigBarChart"
                    chart-id="big-bar-chart"
                    :chart-data="defaultChart.chartData"
                    :extra-options="defaultChart.extraOptions">
        </bar-chart>
      </div>
    </card-component>

        <card-component title="Financial Statements & Ratios" class="has-table">
        <p style="color:navy;">Dollar Units: {{dollarUnits}}</p>
        <nav class="level">
          <!-- Left side -->
          <div class="level-left">
          <b-field class="level-item" label="Balance Sheet Percentage relative to:">
        <b-select v-model="balancedivisor" placeholder="Common-Size" @input="loadTable">
        <<option value="Common-Size" >Common-Size</option>
        <<option value="Assets" >Assets</option>
        <<option value="Liabilities">Liabilities</option>
        <<option value="Equity">Equity</option>
        <<option value="Sales">Sales</option>
        <<option value="Cash">Cash</option>
        <<option value="Profit">Operating Profit</option>
        <<option value="GM">Gross Margin</option>

        </b-select>
        </b-field>

        <b-field class="level-item" label="Income Statement Percentage relative to:">
        <b-select v-model="incomedivisor"  placeholder="Common-Size" @input="loadTable">
        <<option value="Common-Size" >Common-Size</option>
        <<option value="Sales">Sales</option>
        <<option value="Cash">Cash</option>
        <<option value="Profit">Operating Profit</option>
        <<option value="GM">Gross Margin</option>
        <<option value="Assets" >Assets</option>
        <<option value="Liabilities">Liabilities</option>
        <<option value="Equity">Equity</option>


        </b-select>
        </b-field>

          </div>
        </nav>


                       <b-table :data="fslines" :striped="true">

                         <template slot-scope="props" slot="header">
                           <div style="color: red">{{ props.column.label }}</div>
                           <b-icon
                             v-if="props.column.meta"
                             pack="fas"
                             icon="info-circle"
                             size="is-small">
                           </b-icon>
                         </template>

                         <template slot-scope="props">
                           <template v-for="column in columns">
                             <b-table-column :field="column.field" :label="column.label" :numeric="column.numeric" :centered="column.centered" :meta="column.meta" :width="column.width">
                               {{props.row[column.field]}}
                             </b-table-column>
                           </template>

                         </template>

                       </b-table>
                       <div class="boxer">
                                            <div class="field is-grouped">
                                                <p class="control is-expanded">
                                                <button class="button is-primary" @click="downloadCSV">Download Excel (CSV)</button>

                                                                           </p>
                                            </div>
                                        </div>
                                                </card-component>

  </section>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "./features/Navbar"
import * as chartConfig from './Charts/chart.config'
import CardComponent from './CardComponent'
import Tiles from './Tiles'
import CardWidget from './CardWidget'
import LineChart from './Charts/LineChart'
import LineChartGreat from './Charts/LineChartGreat'
import BarChart from './Charts/BarChart'
import TitleBar from './TitleBar'
import axios from 'axios'
import { REPORT_REQUEST , REPORT_RESTAPI } from "../store/actions/report";
import { mapState , mapGetters} from "vuex";

export default {
  name: 'ViewReport',
  components: {
    TitleBar,
    CardWidget,
    Tiles,
    CardComponent,
    LineChart,
    LineChartGreat,
    BarChart,
    Navbar
  },
  data () {
    return {
    fsparameters: {},
    industryname: "",
    geography: "",
    salesSize:"",
    naics:"",
    dollarUnits:"(thousands)",
    firms: 0,
    sales: 0.0,
    growth: 0.0,
    grossmargin: 0.0,
    profitmargin: 0.0,
    assets2sales: 0.0,
    lineChartData: [],
    lineChartDataGreat: [],
    rangeLookup: [],
    barChartData_this: [],
    barChartData_us6: [],
    barChartData_us3: [],
      defaultChart: {
        chartData: null,
        extraOptions: chartConfig.chartOptionsMain
      },
      lineChart: {
        chartData: null,
        extraOptions: chartConfig.chartOptionsMain
      },
        lineChartGreat: {
        chartData: null,
        extraOptions: chartConfig.chartOptionsMain
      },
          incomedivisor: null,
      balancedivisor: null,
      clients: [],
      fslines: [],
      fsdata: [],
      isLoading: false,
      paginated: false,
      perPage: 10,
      columns: [
    {
        field: 'balancelabel',
        label: 'Balance Item',
    },
    {
        field: 'balancepercent',
        label: 'Pct(%)',
        width: 30,
    },
        {
        field: 'balancevalue',
        label: 'Dollars',
        width: 60,
    },
    {
        field: 'incomelabel',
        label: 'Income Item',
    },
    {
        field: 'incomepercent',
        label: 'Pct(%).',
        width: 30,
    },
        {
        field: 'incomevalue',
        label: 'Dollars ',
        width: 60,
    },
    {
        field: 'ratiolabel',
        label: 'Ratio',
    },
    {
        field: 'ratiovalue',
        label: 'Value',
        width: 60,
  }
    ]

    }
  },
  computed: {
  ...mapState({
  mapaxiosData: state => state.report.axiosData,
  rvp: state => state.report.reportViewParameters,
  status: state => state.report.status,
  })
  },
  watch: {
    status(thenew, theold) {
    console.log("status:",theold,thenew )

    if( thenew=="success") {
    this.loadAxiosData()
    this.loadTableData()
    }
    }
  },
  mounted () {
    this.$store.commit(REPORT_RESTAPI, this.$api.REST_API)

  this.getNumbers()
  //this.fillChartData()
  this.fillBarChartData()

  },
  methods: {

    loadAxiosData() {
    this.rangeLookup[ "03"] = "Less than $250K"
this.rangeLookup[ "04"] = ">$250-$500K"
this.rangeLookup[ "05"] = "$500K-$1M"
this.rangeLookup[ "06"] = "$1M-$2.5M"
this.rangeLookup[ "07"] = "$2.5M-$5M"
this.rangeLookup[ "08"] = "$5M-10M"
this.rangeLookup[ "09"] = "$10M-25M"
this.rangeLookup[ "10"] = "$25M-50M"
this.rangeLookup[ "11"] = "$50M-100M"
this.rangeLookup[ "12"] = "$100M-250M"
this.rangeLookup[ "13"] = "$250M-500M"
this.rangeLookup[ "14"] = "$500M plus"


    console.log(this.mapaxiosData)
    var axiosData = this.mapaxiosData
      this.dollarUnits = axiosData.units.charAt(0).toUpperCase() +  axiosData.units.substr(1).toLowerCase()
      this.naics = axiosData.naics
      if( this.rvp.salesType == "Exact") {
          this.salesSize = "Custom"
      } else {
      this.salesSize = this.rangeLookup[ this.rvp.range]

      }
      this.geography = "National"
      this.industryname = axiosData.naicsdescription
      this.firms = axiosData.firms
      this.sales = axiosData.sales.toFixed(1)
      this.growth = (axiosData.growth5-1)*100.00
      this.growth = this.growth.toFixed(2)
      this.grossmargin = axiosData.income.gm.toFixed(1)
      this.profitmargin = (axiosData.income.profitx + 0.01).toFixed(2)
      this.assets2sales = axiosData.balance.totasset/this.sales
      this.assets2sales = this.assets2sales.toFixed(2)
//      this.$set(this.fsparameters, 'balance',axiosData.balance)
//      this.$set(this.fsparameters, 'income',axiosData.income)
//      this.$set(this.fsparameters, 'sales',this.sales)

console.log(axiosData.saleshistory)
// console.log(axiosData.saleshistory)

        let sh = axiosData.saleshistory
        console.log(sh)
        this.lineChartData.push(sh.yr2015)
        this.lineChartData.push(sh.yr2016)
        this.lineChartData.push(sh.yr2017)
        this.lineChartData.push(sh.yr2018)
        this.lineChartData.push(sh.yr2019)
        this.lineChartData.push(sh.yr2020)

        this.lineChartDataGreat.push(sh.yr2008)
        this.lineChartDataGreat.push(sh.yr2009)
        this.lineChartDataGreat.push(sh.yr2010)

      this.fillChartData()
      this.fillChartDataGreat()

      let bn = axiosData.benchmarksnormalized
      let bn_this = bn.benchmarkthis
      let bn_us6 = bn.benchmarkus6
      let bn_us3 = bn.benchmarkus3

      this.barChartData_this.push(bn_this.sales2emps)
      this.barChartData_this.push(bn_this.profit2emps)
      this.barChartData_this.push(bn_this.cgs2sales)
  //    this.barChartData_this.push(bn_this.inventoryturns)
      this.barChartData_this.push(bn_this.ap2sales)
      this.barChartData_this.push(bn_this.quickratio)
      this.barChartData_this.push(bn_this.currentratio)
      this.barChartData_this.push(bn_this.profitmargin)

      this.barChartData_us6.push(bn_us6.sales2emps)
      this.barChartData_us6.push(bn_us6.profit2emps)
      this.barChartData_us6.push(bn_us6.cgs2sales)
//      this.barChartData_us6.push(bn_us6.inventoryturns)
      this.barChartData_us6.push(bn_us6.ap2sales)
      this.barChartData_us6.push(bn_us6.quickratio)
      this.barChartData_us6.push(bn_us6.currentratio)
      this.barChartData_us6.push(bn_us6.profitmargin)

      this.barChartData_us3.push(bn_us3.sales2emps)
      this.barChartData_us3.push(bn_us3.profit2emps)
      this.barChartData_us3.push(bn_us3.cgs2sales)
//      this.barChartData_us3.push(bn_us3.inventoryturns)
      this.barChartData_us3.push(bn_us3.ap2sales)
      this.barChartData_us3.push(bn_us3.quickratio)
      this.barChartData_us3.push(bn_us3.currentratio)
      this.barChartData_us3.push(bn_us3.profitmargin)

      this.fillBarChartData()
    },

    getNumbers() {
    console.log("**ViewReport.vue--getNumbers()***")

  var theman = { username: "Neil", password: "Young" }
  //  const { username: "Neil", password: "Young" } = this;
  this.$store.dispatch(REPORT_REQUEST, theman  ).then(() => {
  //  this.$router.push("/oops");

    //	this.$router.push('/dashboard')
    });

    console.log("****ViewReport.vue--after dispatch******")


    },
    randomChartData (n) {
      let data = []

      for (let i = 0; i < n; i++) {
        data.push(Math.round(Math.random() * 200))
      }

      return data
    },
    fillBarChartData () {
      this.defaultChart.chartData = {
        datasets: [
          {
          label: 'Your NAICS',
          borderColor: '#eca72c',
          backgroundColor: '#eca72c',
          borderWidth: 2,
           hoverBackgroundColor: '#eca72c',
         data: this.barChartData_this
          },
          {
          label: 'National NAICS Subsector (3-digit)',
          borderColor: '#ee5622',
          backgroundColor: '#ee5622',
          hoverBackgroundColor: '#ee5622',
          data: this.barChartData_us3

          },
          {
          label: 'National All NAICS',
          borderColor: '#1098f7',
          backgroundColor: '#1098f7',
          hoverBackgroundColor: '#1098f7',
          data: this.barChartData_us6
          },
        ],
        labels: ['Sales/Emps', 'Op Profit/Emps', 'CGS/Sales',  'AP/Sales', 'Quick Ratio', 'Current Ratio', 'Profit Margin']
      }
    },
    fillChartData () {
      this.lineChart.chartData = {
        datasets: [
          {
          label: 'Annual Sales',
            fill: false,
            borderColor: chartConfig.chartColors.default.info,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            lineTension: 0,
            pointBackgroundColor: 'green',
            pointBorderColor: 'rgba(255,255,255,0)',
            pointHoverBackgroundColor: chartConfig.chartColors.default.info,
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: this.lineChartData
          }
        ],
        labels: ['2015', '2016','2017','2018','2019','2020' ]
      }
    },
     fillChartDataGreat () {
      this.lineChartGreat.chartData = {
        datasets: [
          {
          label: 'Annual Sales',
            fill: false,
            borderColor: chartConfig.chartColors.default.info,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            lineTension: 0,
            pointBackgroundColor: 'green',
            pointBorderColor: 'rgba(255,255,255,0)',
            pointHoverBackgroundColor: chartConfig.chartColors.default.info,
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: this.lineChartDataGreat
          }
        ],
        labels: ['2008', '2009','2010' ]
      }
    },
       loadTableData() {
    console.log("loadTableData():")
    console.log(this.fsparameters)

    var axiosData = this.mapaxiosData

    console.log("axiosData")
    console.log(axiosData)


    if( this.incomedivisor  )
    {

    } else {
        this.incomedivisor = "Common-Size"
    }
    if( this.balancedivisor )
    {

    } else {
        this.balancedivisor = "Common-Size"
    }
      console.log( this.incomedivisor)
      console.log( this.balancedivisor)


  //    this.sales = axiosData.sales
      this.$set(this.fsparameters, 'balance',axiosData.balance)
      this.$set(this.fsparameters, 'income',axiosData.income)
  //      this.$set(this.fsparameters, 'sales',this.sales)
  //  this.fslines.push ( { balancelabel: "Line Item", balancevalue: "Dollars",   incomelabel: 'Line Item', incomevalue: "Dollars", ratiolabel: 'Metric', ratiovalue: "Value"   })


    this.fsdata = []
    var div_balance = {common: axiosData.balance.totasset, sales: axiosData.sales, profit:  axiosData.income.profitx, gm: axiosData.income.gm, assets: axiosData.balance.totasset ,
    cash: this.fsparameters.balance.cash ,
      liabilities:  axiosData.balance.tdebt,  equity: axiosData.balance.networthequity }
      var div_income = {common: axiosData.sales, sales: axiosData.sales, profit:  axiosData.income.profitx, gm: axiosData.income.gm, assets: axiosData.balance.totasset ,
      cash: this.fsparameters.balance.cash ,
        liabilities:  axiosData.balance.tdebt,  equity: axiosData.balance.networthequity }

  this.fsdata.push ( { balancelabel: "Cash", balancevalue: this.fsparameters.balance.cash ,
      divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
      incomelabel: "Sales", incomevalue:  axiosData.sales,
       ratiolabel: "Debt/Equity", ratiovalue: axiosData.ratios.debt2equity  })

       this.fsdata.push ( { balancelabel: "Net A/R", balancevalue: axiosData.balance.nar ,
       divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
           incomelabel: "Cost of Goods Sold", incomevalue:  axiosData.income.cogs,
            ratiolabel: "Return on Assets", ratiovalue: axiosData.ratios.returnonassets  })

            this.fsdata.push ( { balancelabel: "Inventory", balancevalue: axiosData.balance.inventory ,
            divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
                incomelabel: "Gross Margin", incomevalue:  axiosData.income.gm,
                 ratiolabel: "Profit / CGS", ratiovalue: axiosData.ratios.profit2cgs  })

                 this.fsdata.push ( { balancelabel: "Other Current Assets", balancevalue: axiosData.balance.othcur ,
                 divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
                     incomelabel: "Advertising", incomevalue:  axiosData.income.adv,
                      ratiolabel: "", ratiovalue: null   })

                      this.fsdata.push ( { balancelabel: "Current Assets", balancevalue: axiosData.balance.curasset ,
                      divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
                          incomelabel: "Salaries & Wages", incomevalue:  axiosData.income.wages,
                          ratiolabel: "", ratiovalue: null   })

                     this.fsdata.push ( { balancelabel: "Long Term Investments", balancevalue: axiosData.balance.invest ,
                     divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
                             incomelabel: "Employee Benefits", incomevalue:  axiosData.income.empben,
                             ratiolabel: "", ratiovalue: null   })

                    this.fsdata.push ( { balancelabel: "Plant, Property & Equipment", balancevalue: axiosData.balance.fixasset ,
                    divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
                              incomelabel: "Pension & Annuity", incomevalue:  axiosData.income.pension,
                              ratiolabel: "", ratiovalue: null   })

                   this.fsdata.push ( { balancelabel: "Other Assets", balancevalue: axiosData.balance.othasset ,
                   divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
                             incomelabel: "Officer Compensation", incomevalue:  axiosData.income.offcmp,
                             ratiolabel: "", ratiovalue: null   })

                  this.fsdata.push ( { balancelabel: "Total Assets", balancevalue: axiosData.balance.totasset ,
                  divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
                            incomelabel: "Bad Debt", incomevalue:  axiosData.income.bdebt,
                            ratiolabel: "", ratiovalue: null   })


  div_balance.common = div_balance.liabilities + div_balance.equity
  this.fsdata.push ( { balancelabel: "Accounts Payable", balancevalue: axiosData.balance.ap ,
  divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
  incomelabel: "Rent Paid", incomevalue:  axiosData.income.rent,
  ratiolabel: "", ratiovalue: null   })


  this.fsdata.push ( { balancelabel: "Other Current Liabilities", balancevalue: axiosData.balance.othliab ,
  divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
  incomelabel: "Repairs", incomevalue:  axiosData.income.repair,
  ratiolabel: "", ratiovalue: null   })

  this.fsdata.push ( { balancelabel: "Total Current Liabilities", balancevalue: axiosData.balance.totalcurrentliab ,
  divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
  incomelabel: "Depreciation / Amort", incomevalue:  axiosData.income.deprec,
  ratiolabel: "", ratiovalue: null   })


  this.fsdata.push ( { balancelabel: "Long-Term Debt", balancevalue: axiosData.balance.ltliab ,
  divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
  incomelabel: "Interest Paid", incomevalue:  axiosData.income.interest,
  ratiolabel: "", ratiovalue: null   })

  this.fsdata.push ( { balancelabel: "Total Liabilities", balancevalue: axiosData.balance.tdebt ,
  divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
  incomelabel: "Misc Expenses", incomevalue:  axiosData.income.othded,
  ratiolabel: "", ratiovalue: null   })

  this.fsdata.push ( { balancelabel: "Net Worth / Equity", balancevalue: axiosData.balance.networthequity ,
  divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
  incomelabel: "Taxes Paid", incomevalue:  axiosData.income.taxpd,
  ratiolabel: "", ratiovalue: null   })

  this.fsdata.push ( { balancelabel: "", balancevalue: ''  ,
  divisor_balance: Object.assign({},div_balance), divisor_income: Object.assign({},div_income),
  incomelabel: "Operating Profit", incomevalue:  axiosData.income.profitx,
  ratiolabel: "", ratiovalue: null   })

  console.log(this.fsdata)
    var dp = this.loadTable()


    },

    loadTable() {
    this.fslines.length = 0
    this.fsdata.forEach((element, index, array) => {
  //  console.log("********************ELEMENT*********************");
  //  console.log(element);

        // make sure we adjust properly given the selected
        var i_divisor = 0.0
        var b_divisor = 0.0

        switch (this.balancedivisor ) {
          case "Common-Size":
              b_divisor = element.divisor_balance.common ;
              break;
              case "Sales":
                  b_divisor = element.divisor_balance.sales ;
                  break;
                  case "Cash":
                      b_divisor = element.divisor_balance.cash ;
                      break;
                      case "Profit":
                          b_divisor = element.divisor_balance.profit ;
                          break;
                          case "GM":
                              b_divisor = element.divisor_balance.gm ;
                              break;
                              case "Assets":
                                  b_divisor = element.divisor_balance.assets ;
                                  break;
                                  case "Liabilities":
                                      b_divisor = element.divisor_balance.liabilities ;
                                      break;
                                      case "Equity":
                                          b_divisor = element.divisor_balance.equity ;
                                          break;

        }
        switch (this.incomedivisor ) {
          case "Common-Size":
              i_divisor = element.divisor_income.common ;
              break;
              case "Sales":
                  i_divisor = element.divisor_income.sales ;
                  break;
                  case "Cash":
                      i_divisor = element.divisor_income.cash ;
                      break;
                      case "Profit":
                          i_divisor = element.divisor_income.profit ;
                          break;
                          case "GM":
                              i_divisor = element.divisor_income.gm ;
                              break;
                              case "Assets":
                                  i_divisor = element.divisor_income.assets ;
                                  break;
                                  case "Liabilities":
                                      i_divisor = element.divisor_income.liabilities ;
                                      break;
                                      case "Equity":
                                          i_divisor = element.divisor_income.equity ;
                                          break;

        }

        var rvalue = null
        var bvalue = null
        var ivalue = null
        var bpct = null
        var ipct = null
        if( element.ratiolabel != "") {
          rvalue = element.ratiovalue.toFixed(2)
        }

        if( element.balancelabel != "") {

          bvalue = "$"  + element.balancevalue.toFixed(1)
          if( b_divisor != 0 ) {
              bpct = ((element.balancevalue / b_divisor)*100).toFixed(1) + "%"
          }
        }
        if( element.incomelabel != "") {

          ivalue = "$" + element.incomevalue.toFixed(1)
          if( i_divisor != 0 ) {
              ipct = ((element.incomevalue / i_divisor)*100).toFixed(1) + "%"
          }
        }



              var myrow = { balancelabel: element.balancelabel, balancepercent: bpct, balancevalue: bvalue,
        incomelabel: element.incomelabel,    incomepercent: ipct , incomevalue: ivalue,
        ratiolabel: element.ratiolabel, ratiovalue: rvalue         }
    //    console.log("********************myrow*********************");

        if( true) {
        this.fslines.push(myrow)
        }
    //    console.log(myrow);
        // console.log(array); // same myArray object 3 times

    });

      this.fslines = this.fslines.slice(0)
    },

    downloadCSV() {

    var URI = this.$api.REST_API + '/Reports/NormCSV'

    axios
      .post(URI, {naics: "238110", range: "03", state: "", zip: "" })
      .then(r => {
      console.log(r)
      var fileURL = window.URL.createObjectURL(new Blob([axiosData]));
  var fileLink = document.createElement('a');

  fileLink.href = fileURL;
  fileLink.setAttribute('download', 'file.csv');
  document.body.appendChild(fileLink);

  fileLink.click();
      })
      .catch(e => {
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ViewReport.vue